import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import { MultiValuedListItem } from '../../MultiValuedList'
import Text from '../../Text'

import * as styles from './TextMultiValuedListMoreItem.module.css'

function TextMultiValuedListMoreItem({
  children,
  className = styles.TextMultiValuedListMoreItem,
  disabled,
  isSecondary,
  unread,
  ...itemProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const textProps = {
    children,
    disabled,
    isSecondary,
    unread,
  }

  return children ? (
    <MultiValuedListItem {...itemProps} className={className}>
      <FloatingTooltip content={children} disabled={!overflow}>
        <Text {...textProps} ref={setContentOverflowRef} />
      </FloatingTooltip>
    </MultiValuedListItem>
  ) : null
}

export default TextMultiValuedListMoreItem
